<template>
    <div>

        <a-modal
          v-if="selectedPlugin != null"
          title="Warning"
          :visible="modalVisible"
          @ok="installPlugin(selectedPlugin.id)"
          @cancel="closeModal"
        >
        
            <b>Are you sure you want to install this plugin?</b><br/><br/>
            This plugin will have access to the ff: <br/><br/>
            <ul style="width: 100%">
                <li v-for="permission in modelPermissions" :key=permission>
                    {{permission}}
                </li>
            </ul>
           
        </a-modal>

        <base-header type="gradient-primary" class="pb-6 pb-8 pt-5 pt-md-8">
            <br> <br>
            <base-dropdown >
                <base-button slot="title" type="success" class="dropdown-toggle">
                    Plugin Manager - {{ _.startCase(selectedProfile)}}
                </base-button>
                <a @click.prevent="setCurrentProfile('pos_plugins')" class="dropdown-item" href="#">POS Plugins</a>
                <a @click.prevent="setCurrentProfile('backend_plugins')" class="dropdown-item" href="#">Backend Plugins</a>
            </base-dropdown>
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">   
                    <div v-if="selectedProfile == 'pos_plugins'" class="card mb-3">
                      <div class="row no-gutters" style="height: 70vh; max-height: 70vh;">
                        <div class="col-md-4" style="border-right: 1px solid #e0e0e0">
                          <div class="card-body">
                            <div class="row">
                                <div class="col-md-7 no-gutters">
                                    <h3 class="card-title">Installed Plugins</h3>
                                </div>

                                <div v-if="formVisble == false" class="col-md-5 float-right"><button @click="showPluginForm()" class="btn btn-sm btn-primary" style="border-radius: 24px; background-color: #0569FF; border:0px; width: 100%;"> + Add Plugin </button></div>
                                <div v-if="formVisble == true" class="col-md-5 float-right">
                                    <a-popconfirm title='Are you sure you want to cancel?' class="btn btn-sm btn-danger" style="border-radius: 24px; border:0px; width: 100%;" @confirm="() => showPluginForm()">
                                        Cancel
                                    </a-popconfirm>
                                </div>

                                <div class="col-md-12">
                                    <ul v-if="accountPosPlugins.length > 0" class="list-group" style="width: 100%">
                                        <li class="list-group-item" style="font-size: 14px" v-for="posPlugin in accountPosPlugins" :key=posPlugin.id @click="getPlugin(posPlugin.id)">
                                            <span v-if="posPlugin.status == 'A'" class="fa fa-check-circle text-green"/> 
                                            <span v-else class="fa fa-check-circle"/> 
                                            {{posPlugin.name}} <br>
                                            <small>Author: {{posPlugin.author}} </small>   
                                        </li>
                                    </ul>
                                </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-8">
                          <div class="card-body">
                             <div class="row">
                                <div class="col-md-9" >
                                    <div v-if="formVisble == true && this.plugin.id != undefined">
                                        <h3>{{ plugin.name}} Configuration</h3>
                                        <small>By: {{plugin.author}} | {{ plugin.company }}</small>
                                    </div>
                                    <h3 class="card-title" v-if="formVisble == true && this.plugin.id == undefined">Plugins Store</h3>
                                </div>
                                <div v-if="formVisble == true" class="col-md-3 float-right">
                                    <button @click="changePluginStatus(plugin.id)" v-if="plugin.id != undefined && plugin.status == 'I'" class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 100%;" type="primary" >
                                        Activate
                                    </button>
                                    <button @click="changePluginStatus(plugin.id)" v-if="plugin.id != undefined && plugin.status == 'A'" class="btn btn-sm btn-danger float-right" style="border-radius: 24px; border:0px; width: 100%;" type="primary" >
                                        Deactivate
                                    </button>
                                </div>

                                <div class="col-md-12" v-if="formVisble == true" style="padding: 15px; width: 100%;">
                                    <div v-if="plugin.id == undefined">
                                        <b-input-group>
                                            <template v-slot:prepend>
                                                <b-dropdown :text="filterCaption" variant="outline-default">
                                                    <b-dropdown-item @click.prevent="changeFilter('name')">Name</b-dropdown-item>
                                                    <b-dropdown-item @click.prevent="changeFilter('author')">Author</b-dropdown-item>
                                                    <b-dropdown-item @click.prevent="changeFilter('company')">Company</b-dropdown-item>
                                                </b-dropdown>
                                            </template>

                                            <b-form-input style="padding:5px; height: 44px;"></b-form-input>

                                            <template v-slot:append>
                                              <b-button variant="outline-default"><span class="fa fa-search"/></b-button>
                                            </template>
                                        </b-input-group>

                                        <br>
                                        <ul v-if="posPlugins.length > 0" class="list-group" style="height: 70vh; max-height: 40vh; overflow: scroll; width: 100%;">
                                            <li class="list-group-item" style="font-size: 14px" v-for="posPlugin in posPlugins" :key=posPlugin.id>
                                                <div class="row">
                                                    <div class="col-md-8">
                                                        {{posPlugin.name}} 
                                                    </div>
                                                    <div class="col-md-4">
                                                        <button type="primary" class="btn btn-sm btn-primary float-right" @click="openModal(posPlugin)"><span class="fa fa-download"></span> &nbsp; Install</button>
                                                    </div>
                                                    <div class="col-md-12">
                                                        <small>Author: {{posPlugin.author}} </small> 
                                                    </div>  
                                                </div>
                                            </li>
                                        </ul>
                                        <div v-else>
                                            <small>No available plugin for installation.</small>
                                        </div>
                                    </div>
                                    <div v-else :key="pluginViewKey">
                                        <br>
                                        <div class="row">
                                            <div class="col-md-10"> 
                                                <h4>Auto-download</h4>
                                                <small>This plugin will not prompt installation notice on the terminal.</small>
                                            </div>
                                            <div class="float-right col-md-2"><a-switch/></div>
                                        </div>
                                        <br>
                                        <div class="row">
                                            <div class="col-md-10"> 
                                                <h4>All sites</h4>
                                                <small>This plugin will be made available for all sites.</small>
                                            </div>
                                            <div class="float-right col-md-2"><a-switch/></div>
                                        </div>

                                    </div>

                                </div>
                                <div v-else>
                                    &nbsp; &nbsp; <small>Please select a plugin to configure or click "Add" to install more plugins.</small>
                                </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else class="card mb-3">
                        <div class="row no-gutters" style="height: 70vh; max-height: 70vh;">
                        <div class="col-md-4" style="border-right: 1px solid #e0e0e0">
                          <div class="card-body">
                            <div class="row">
                                <div class="col-md-7 no-gutters"><h3 class="card-title">Backend Plugins</h3></div>

                                <div v-if="formVisble == false" class="col-md-5 float-right"><button @click="showPluginForm()" class="btn btn-sm btn-primary" style="border-radius: 24px; background-color: #0569FF; border:0px; width: 100%;"> + Add Plugin</button></div>
                                <div v-if="formVisble == true" class="col-md-5 float-right">
                                    <a-popconfirm title='Are you sure you want to cancel?' class="btn btn-sm btn-danger" style="border-radius: 24px; border:0px; width: 100%;" @confirm="() => showPluginForm()">
                                        Cancel
                                    </a-popconfirm>
                                </div>

                                <div class="col-md-12">
                                    <ul v-if="accountBackendPlugins.length > 0" class="list-group" style="width: 100%">
                                        <li class="list-group-item" style="font-size: 14px" v-for="backendPlugin in accountBackendPlugins" :key=backendPlugin.id @click="redirectTo(backendPlugin.redirect_link)">
                                            <span v-if="backendPlugin.status == 'A'" class="fa fa-check-circle text-green"/> 
                                            <span v-else class="fa fa-check-circle"/> 
                                            {{backendPlugin.name}} <br>
                                            <small>Author: {{backendPlugin.author}} </small>   
                                        </li>
                                    </ul>
                                </div>

                            </div>
                          </div>
                        </div>
                        <div class="col-md-8">
                          <div class="card-body">
                             <div class="row">
                                <div class="col-md-12"><h3 class="card-title">Backend Plugin Configuration</h3></div>

                                <div class="col-md-12" v-if="formVisble == true" style="padding: 15px; width: 100%;">
                                    <b-input-group>
                                        <template v-slot:prepend>
                                            <b-dropdown :text="filterCaption" variant="outline-default">
                                                <b-dropdown-item @click.prevent="changeFilter('name')">Name</b-dropdown-item>
                                                <b-dropdown-item @click.prevent="changeFilter('author')">Author</b-dropdown-item>
                                                <b-dropdown-item @click.prevent="changeFilter('company')">Company</b-dropdown-item>
                                            </b-dropdown>
                                        </template>

                                        <b-form-input style="padding:5px; height: 44px;"></b-form-input>

                                        <template v-slot:append>
                                          <b-button variant="outline-default"><span class="fa fa-search"/></b-button>
                                        </template>
                                    </b-input-group>

                                    <br>
                                    <ul v-if="backendPlugins.length > 0" class="list-group" style="height: 70vh; max-height: 40vh; overflow: scroll; width: 100%;">
                                        <li class="list-group-item" style="font-size: 14px" v-for="backendPlugin in backendPlugins" :key=backendPlugin.id>
                                            <div class="row">
                                                <div class="col-md-8">
                                                    {{backendPlugin.name}} 
                                                </div>
                                                <div class="col-md-4">
                                                    <button type="primary" class="btn btn-sm btn-primary float-right" @click="installBackendPlugin(backendPlugin.id)"><span class="fa fa-download"></span> &nbsp; Install</button>
                                                </div>
                                                <div class="col-md-12">
                                                    <small>Author: {{backendPlugin.author}} </small> 
                                                </div>  
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div v-else class="col-md-12">
                                    <small>No available plugin for installation.</small>
                                </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import ValidateField from '../../components/validateFormUtils.js'
    import axios from "axios";
    import VueJsonPretty from 'vue-json-pretty'
    import { mapState, mapActions } from 'vuex'
    var component_x;
    export default {
        components:{
            VueJsonPretty
        },
        mounted: async function(){  
            component_x = this;
            this.getPluginInfo()
        },
        computed: {
             ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
        },
        data() {
          return {
            pluginViewKey: 0,
            errors: [],
            accountPosPlugins: [],
            accountBackendPlugins: [],
            posPlugins: null,
            backendPlugins: null,
            selectedPlugin: null,
            selectedProfile: "pos_plugins",
            formVisble: false,
            filterField: "name",
            filterCaption: "Search by name",
            modalVisible: false,
            pluginId: null,
            selectedPlugin: null,
            modelPermissions: []
          }
        },
        methods: {
            ...mapActions(['updateCurrentProfile', 'updateParameters']),
            closeModal(){
                this.modalVisible = false
                this.selectedPlugin = null
                this.modelPermissions = []
            },
            openModal(plugin){
                this.modalVisible = true
                this.selectedPlugin = plugin
                var permissions = JSON.parse(this.selectedPlugin.configuration).permissions
                for(var i=0; i < permissions.length; i++){
                    this.modelPermissions.push(permissions[i].model)
                }
            },
            async getPluginInfo(){
                if(this.selectedProfile == "pos_plugins"){
                    var response = await HTTPRequest.getRequest(this.endPoint + "/account_pos_plugins", null)
                    this.accountPosPlugins = response
                    var response = await HTTPRequest.getRequest(this.endPoint + "/pos_plugins?account=" + secureStorage.getItem("accountName"), null)
                    this.posPlugins = response.data
                } else {
                    var response = await HTTPRequest.getRequest(this.endPoint + "/account_backend_plugins", null)
                    this.accountBackendPlugins = response
                    var response = await HTTPRequest.getRequest(this.endPoint + "/pos_plugins?account=" + secureStorage.getItem("accountName"), null)
                    var response = await HTTPRequest.getRequest(this.endPoint + "/backend_plugins?account=" + secureStorage.getItem("accountName"), null)
                    this.backendPlugins = response.data
                }
                
            },
            setCurrentProfile(profile){
                this.selectedProfile = profile
                this.getPluginInfo()
            },
            showPluginForm(){
                this.formVisble = !this.formVisble,
                this.current = 0
                this.plugin = {}
            },
            async getPlugin(pluginId){
                var response = await HTTPRequest.getRequest(this.endPoint + "/account_pos_plugins/" + pluginId , null)
                this.plugin = response
                this.formVisble = true
                this.pluginViewKey++;
            },
            changeFilter(field){
              this.filterField = field
              this.filterCaption = "Search by " + _.startCase(this.filterField)
            },
            async installPlugin(pluginId){
                var accountPlugin = {account_pos_plugin: { pos_plugin_id: pluginId, status: "I"}}
                var response = await HTTPRequest.postRequest(this.endPoint + "/account_pos_plugins" , null, accountPlugin)
                this.$notification['success']({
                    message: this.selectedPlugin.name + ' was installed successfully.',
                    description: "You can configure and activate it in your the Installed Plugins panel"
                });
                this.getPluginInfo()
                this.formVisble = false
                this.selectedPlugin = null
                this.modalVisible = false
                this.modelPermissions = []
            },
            async installBackendPlugin(pluginId){
                var accountPlugin = {account_backend_plugin: { backend_plugin_id: pluginId, status: "A"}}
                var response = await HTTPRequest.postRequest(this.endPoint + "/account_backend_plugins" , null, accountPlugin)
                this.$notification['success']({
                    message: ' Plugin was installed successfully.',
                    description: "You can open the plugin in your the Installed Plugins panel"
                });
                this.getPluginInfo()
                this.formVisble = false
                this.selectedPlugin = null
            },
            async changePluginStatus(pluginId){
                var pluginDetails;
                if(this.plugin.status == "A"){
                    pluginDetails = {account_pos_plugin: {status: "I"}}
                }else{
                    pluginDetails = {account_pos_plugin: {status: "A"}}
                }
                var response = await HTTPRequest.putRequest(this.endPoint + "/account_pos_plugins/" + pluginId , null, pluginDetails)
                this.getPluginInfo()
                this.formVisble = false
            },
            redirectTo(link){
                console.log(link)
                window.open( link + "?" + secureStorage.getItem("accessToken"), '_blank');
            }
           
        }
    }
</script>

<style scoped>
</style>


